import { Dots } from 'react-activity';
import 'react-activity/dist/Dots.css';
import './index.css';
import View from '../view';
import Text from '../text';
import useTheme from '../../utilities/hooks/theme';

const PaginationIndicator = () => {
  const { ComponentTheme: theme } = useTheme();

  const color = {
    color: theme.paginationIndicator
  };

  return (
    <View className={'pagination-indicator-container'}>
      <Dots color={theme.paginationIndicator} size={20} speed={1} animating={true} />
      <Text style={color} className={'pagination-indicator-title'}>
        {'Loading More....'}
      </Text>
    </View>
  );
};
export default PaginationIndicator;
